module.exports = __webpack_public_path__ + "img/Efdot-Shirt-Blue-01.9faa6254.jpg";